<template>
  <div v-if="editEmailGroup" class="d-flex align-items-center">
    <GuInput v-model="emailGroupName" size="sm" />
    <i v-if="updateRequestInProgress" class="bx bx-loader-alt bx-spin ms-2" />
    <GuButton 
      variant="primary"
      size="sm"
      class="ms-2"
      :disabled="updateRequestInProgress"
      @click="saveEditEmailGroup"
    >
      Save
    </GuButton>
    <GuButton 
      variant="secondary"
      size="sm"
      class="ms-2"
      :disabled="updateRequestInProgress"
      @click="editEmailGroup = false"
    >
      Cancel
    </GuButton>
  </div>
  <div v-else class="d-flex align-items-center">
    <a href="#" @click="selectEmailGroup(emailGroup)">
      {{ emailGroup.name }}
    </a>
    <i class="bx bx-edit ms-2" @click="editEmailGroup = true" />
  </div>
</template>

<script setup>
import { updateCompanyEmailGroup } from '@companies/api/companies.api'
import { ref, defineProps } from 'vue'
import { useToast } from '@shared/gu-components/toast'
import { GuButton } from '@shared/gu-components/button'
import { GuInput } from '@shared/gu-components/input'


const { toast } = useToast()

const props = defineProps({
  company: {
    type: Object,
    required: true,
  },
  emailGroup: {
    type: Object,
    required: true,
  },
})

const emailGroupName = ref(props.emailGroup.name)
const editEmailGroup = ref(false)
const updateRequestInProgress = ref(false)

const emits = defineEmits(['emailGroupSelected','emailGroupUpdated'])

const { mutateAsync: updateCompanyEmailGroupMutation } = updateCompanyEmailGroup(props.company.id, props.emailGroup.id)
async function saveEditEmailGroup () {
  try {
    updateRequestInProgress.value = true
    const response = await updateCompanyEmailGroupMutation({ 
      emailGroupName: emailGroupName.value,
    })
    emits('emailGroupUpdated', {
      id: response.id,
      name: response.name,
      updatedAt: response.updatedAt,
    })
    setTimeout (() => toast({
      variant: 'success',
      description: `Email group name updated successfully to "${response.name}"`,
    }), 0)
    editEmailGroup.value = false
  } catch (error) {
    console.error('Error updating email group:', error)
    toast({
      variant: 'danger',
      description: error?.response?.data?._message || 'Error updating email group, please try again',
      duration: Infinity,
    })
  }
  updateRequestInProgress.value = false
}

function selectEmailGroup (emailGroup) {
  emits('emailGroupSelected', emailGroup)
}
</script>
